import React from 'react';

import { Form, Modal, Typography } from 'antd';
import { Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';

import { useNotification } from 'segments/hooks/useNotification';

import { SubmiteButton, WeekPicker } from 'shared/FormItems';
import { ModalFooter } from 'shared/Modals';

import { SelectBookingTime } from 'features/bookingTimeSelector';
import { CreateCoachBooking, SelectedBookingCoach, useCreateCoachBookingMutation, } from 'features/coachesBooking';

interface FormData extends Omit<CreateCoachBooking, 'startTime' | 'endTime' | 'repeatUntil'> {
  startTime: Dayjs;
  repeatUntil: Dayjs;
  endTime: Dayjs;
}

interface Props {
  isModalOpen: boolean;
  handleCancel: () => void;
  initData?: SelectedBookingCoach;
}

const BookingCoachModal = ({ isModalOpen, handleCancel, initData }: Props) => {
  const { t } = useTranslation();

  const [form] = Form.useForm<FormData>();

  const [create, { isSuccess, isError, isLoading, error }] = useCreateCoachBookingMutation();

  useNotification({
    isSuccess,
    isError,
    error,
    onSuccess: () => handleCancel(),
    onError: () => handleCancel()
  });

  if (initData === undefined) {
    return;
  }

  const bookingStartTime = initData.startTime;
  const onFinish = ({ endTime, repeatUntil, ...values }: FormData) => {
    const formatedEndTime =
      endTime.year(bookingStartTime.year()).month(bookingStartTime.month()).date(bookingStartTime.date()).format('YYYY-MM-DDTHH:mm');
    create({
      ...values,
      coachId: initData.coachId,
      startTime: bookingStartTime.format('YYYY-MM-DDTHH:mm'),
      endTime: formatedEndTime,
      ...(repeatUntil !== undefined && { repeatUntil: repeatUntil.format('YYYY-MM-DD') })
    });
  };

  const modalTittle =
    `${t('coaches.title.booking')} ${initData.coachName} ${t('from')} ${bookingStartTime.format('HH:mm')}`;
  return (
    <Modal
      title={modalTittle}
      open={isModalOpen}
      onCancel={handleCancel}
      destroyOnClose
      footer={[
        <ModalFooter
          key="modalFooter"
          handleCancel={handleCancel}
          resetFields={form.resetFields}
        />
      ]}
    >
      <Form
        name="basic"
        layout="vertical"
        form={form}
        initialValues={initData}
        onFinish={onFinish}
        autoComplete="off"
        className="edit-user__form"
      >
        <SelectBookingTime form={form} endLabel={t('form-items.select.coach-booking-end')} />
        <WeekPicker
          startWeek={bookingStartTime}
          formItemsProps={{
            name: 'repeatUntil',
            label: t('form-items.select.coach-booking-until')
          }}
        />
        <Typography.Text style={{ fontSize: '12px' }}>
          *Например, если вы каждую пятницу с 15:00 до 18:00 отсутствуете в клубе, вы можете указать это время на несколько недель вперед.
        </Typography.Text>
        <SubmiteButton submiteText={t('table.booking')} isLoading={isLoading} />
      </Form>
    </Modal >
  );
};

export default BookingCoachModal;
